export const exportCSVFile = (data: File, name: string) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', `${name}_report.csv`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};
